import React from 'react';
type Variant = 'primary' | 'outline' | 'ghost' | 'white';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  as?: 'button' | 'a';
  href?: string;
  children: React.ReactNode;
}
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold px-6 py-3 text-sm sm:text-base transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900';
const variants: Record<Variant, string> = {
  primary: 'bg-brand-cyan text-white shadow-lg shadow-brand-cyan/25 hover:bg-brand-blue hover:-translate-y-0.5',
  outline: 'border border-white/40 text-white hover:bg-white/10 hover:border-white',
  ghost: 'text-white hover:bg-white/10',
  white: 'bg-white text-navy-900 hover:bg-slate-100 hover:-translate-y-0.5 shadow-lg'
};
export function Button({
  variant = 'primary',
  as = 'button',
  href,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (as === 'a') {
    return <a href={href} className={cls} data-id="element-13" data-mp="226ftg28633o1">
        {children}
      </a>;
  }
  return <button className={cls} {...props} data-id="element-14" data-mp="1naq4bv7oqaf3">
      {children}
    </button>;
}